// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
};

export const PATH_PAGE = {
  page404: '/404',
  page500: '/500',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD + '/home',
  general: {},
  payment: {
    manage: path(ROOTS_DASHBOARD, '/admin-payment-documents/manage'),
    new: path(ROOTS_DASHBOARD, '/admin-payment-documents/new'),
    edit: path(ROOTS_DASHBOARD, '/admin-payment-documents/edit'),
  },
  funds: {
    root: path(ROOTS_DASHBOARD, '/funds/manage'),
  },
  settings: {
    root: path(ROOTS_DASHBOARD, '/admin-settings/manage'),
  },
  bank: {
    root: path(ROOTS_DASHBOARD, '/bank-accounts/manage'),
  },

  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    manage: path(ROOTS_DASHBOARD, '/users/manage'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
  },
  drive: {
    root: path(ROOTS_DASHBOARD, '/drive/manage'),
  },
  notification: {
    root: path(ROOTS_DASHBOARD, '/notifications/'),
    detail: path(ROOTS_DASHBOARD, '/notifications/:id'),
  },
};
